import React from 'react';
import { TextV2 } from '@withjoy/joykit';
import type { NameProps } from '../HotelTile.types';

export const Name: React.FC<NameProps> = React.memo(({ children, ...textProps }) => (
  <TextV2
    typographyVariant="hed2"
    color="mono14"
    overflow="hidden"
    textOverflow="ellipsis"
    whiteSpace="nowrap"
    {...textProps}
  >
    {children}
  </TextV2>
));

Name.displayName = 'HotelTile.Name';
